import React from 'react';
import PropTypes from 'prop-types';
import { gameUiTexts } from 'data/ui-texts';
import { calculateCompletionData, getGroupPoints } from 'helpers/game-helper';
import AreaButton from 'components/ui/area-button/area-button';
import Button from 'components/ui/button/button';
import Info from 'components/ui/info/info';
import Logo from 'components/ui/logo/logo';
import InfoBar from 'components/ui/info-bar/info-bar';
import './area.scss';

const Area = ({ scenarioData, group, infoTitle, infoText, routes, id, setCasesId, setPageId, scenarioId}) => {
	const groupName = group.name ? group.name : group.id;
	const groupPoints = getGroupPoints(group);

	return (
		<div className='Area'>
			<div className='Area-header'>
				<div className='Area-logo'><Logo scenarioId={scenarioId} /></div>
				<InfoBar points={groupPoints} iconId='trophy' scenarioId={scenarioId}/>
				<div className='Area-groupName'>
					<InfoBar text={groupName} iconId='person' scenarioId={scenarioId}/>
				</div>	
			</div>

			<div className='Area-contentWrapper'> 
				<div className='Area-sideWrapper'>
					<div className='Area-infoWindow'>
						{(infoTitle && infoText) && 
							<Info 
								title={infoTitle} 
								text={infoText}
								scenarioId={scenarioId}
							/>
						}
					</div>
				</div>
				<div className='Area-middleWrapper'>
					<div className='Area-areaWrapper'>
						<div className={'Area-lines ' + scenarioId}>
							{routes.map((route, index) => {
								const caseTasksData = scenarioData.tasksData[id].filter((c) => {
									return c.caseId === route.id;
								});
								/* Do not show lines for cases with no tasks */
								if (caseTasksData.length === 0) return null;
								
								return <div key={index} className='Area-line' />;
							})}
						</div>
						<div className={'Area-areaButton ' + id + ' ' + scenarioId}>
							<AreaButton
								isSelected={true}
								areaButtonId={id}
								name={infoTitle} 
								scenarioId={scenarioId}
							/>
						</div>	
						<div className={'Area-cases ' + scenarioId}>
							{routes.map((route, index) => {
								const caseTasksData = scenarioData.tasksData[id].filter((c) => {
									return c.caseId === route.id;
								});
								/* Do not show cases with no tasks */
								if (caseTasksData.length === 0) return null;

								const completionData = calculateCompletionData(caseTasksData, group.assignments);
								const style = {width: completionData.completedPercentage + '%'};
								return (
									<div key={index} className={'Area-casesButton ' + scenarioId}>
										<div className="Area-casesLine" />
										<Button
											classes={['blueLight', scenarioId, 'responsive', 
												'noScaling', 'padded', 'maxWidth']} 
											text={route.title + ': ' + route.subtitle}
											onClick={() => {setCasesId(route.id);}}
										/>
										<div className={'Area-completionIndicator ' + scenarioId}>
											<div 
												className={
													'Area-completionIndicatorFill ' + scenarioId +
													(completionData.completedPercentage === 100 ? ' rounded' : '')
												}
												style={style}/>
											<span>{completionData.completionCount + '/' + caseTasksData.length}</span>
										</div>
									</div>
								);
							})}
						</div>
					</div>
				</div>
			</div>
			<div className="Area-backBtn">
				<Button 
					text={gameUiTexts.backBtn}
					classes={['backBtnGame', scenarioId, 'responsive']}
					onClick={() => {setPageId('areaHub');}}
				/>
			</div>
		</div>
	);
};

Area.propTypes = {
	scenarioData: PropTypes.object.isRequired,
	infoTitle: PropTypes.string.isRequired,
	infoText: PropTypes.string.isRequired,
	routes: PropTypes.array.isRequired,
	id: PropTypes.string.isRequired,
	group: PropTypes.object.isRequired,
	setCasesId: PropTypes.func.isRequired,
	setPageId: PropTypes.func.isRequired,
	scenarioId: PropTypes.string.isRequired,
};

export default Area;